import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let addGroupMachine: any;

export const useSMAddGroup = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  addGroupMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(addGroupMachine);

  return {
    addGroupMachine,
    addGroupState: state,
    addGroupSend: send,
  };
};
